import { request } from '../request'
// import { EventSourcePolyfill } from 'event-source-polyfill'
// API 接口定义
export const commonApi = {
  loginPhone (data) {
    return request.post('/admin/platform/phonemanager/loginPhone', data)
  },
  getPhoneContent (data, header) {
    return request.post('/admin/platform/phonemanager/getPhoneContent', data, header)
  },
  publishContent (data, header) {
    return request.post('/admin/platform/contentmanager/publishContent', data, header)
  },
  changePhoneStatus (data, header) {
    return request.post('/admin/platform/phonemanager/changePhoneStatus', data, header)
  }
}
